import Backbone from 'backbone';
import Marketplace from '../../marketplace';
const $ = Backbone.$;

export default {
  run(editor, sender, opts = {}) {
    var command_type = opts.command;
    switch (command_type) {
      case 'add-to-marketplace':
        let control_id = $('.is-component-selected').data('control_id');
        Marketplace.addupdateTemplate(control_id);
        break;

      case 'view-marketplace':
        Marketplace.openMarketPlace(1);
        break;

      case 'open-template-preview':
        Marketplace.openPreview(opts);
        break;
      default:
        console.log(opts);
        break;
    }
  }
};
